export default __webpack_public_path__ + "static/media/safari-chrome-firefox-edge.1cf24773.jpg";